import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmminControlloFormService } from './ammin-controllo-form.service';
import { NormeSrlFormModule } from './norme-srl/norme-srl-form.module';
import { NormeSpaOrdinarioFormModule } from './norme-spa-ordinario/norme-spa-ordinario-form.module';
import { NormeSpaDualisticoFormModule } from './norme-spa-dualistico/norme-spa-dualistico-form.module';
import { NormeSpaMonisticoFormModule } from './norme-spa-monistico/norme-spa-monistico-form.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, NormeSrlFormModule, NormeSpaOrdinarioFormModule, NormeSpaDualisticoFormModule, NormeSpaMonisticoFormModule],
    providers: [AmminControlloFormService],
})
export class AmminControlloFormModule {}
